import { autoUpdate, computePosition, flip, offset } from '@floating-ui/dom';
export default function floatingUI(node, config = {
    placement: 'bottom-start',
    strategy: 'absolute'
}) {
    const referenceEl = node.previousElementSibling;
    function updatePosition() {
        computePosition(referenceEl, node, {
            placement: config?.placement,
            strategy: config?.strategy,
            middleware: [offset(config.offset), flip()]
        }).then(({ x, y }) => {
            Object.assign(node.style, {
                left: `${x}px`,
                top: `${y}px`
            });
        });
    }
    const cleanup = autoUpdate(referenceEl, node, updatePosition, config?.autoUpdate);
    return {
        destroy() {
            cleanup();
        }
    };
}
